import { TRoute } from "@/shared/types/route.ts";
import Login from "@/auth/pages/login.tsx";
import ForgotPassword from "@/auth/pages/forgot-password.tsx";
import AcceptInvite from "@/auth/pages/accept-invite.tsx";


//const RegisterPage = lazy(() => import("@/auth/pages/register.tsx"));

const AUTH_URL = Object.freeze({
  SIGN: "/sign",
  FORGOT_PASSWORD: "/forgot-password",
  ACCEPT_INVITE: "/accept-invite",
});


const LOGIN_ROUTE: TRoute = {
  name: "Login",
  path: AUTH_URL.SIGN,
  component: Login,
};

const FORGOT_PASSWORD_ROUTE: TRoute = {
  name: "Forgot Password",
  path: AUTH_URL.FORGOT_PASSWORD,
  component: ForgotPassword,
};

const ACCEPT_INVITE_ROUTE: TRoute = {
  name: "Accept Invite",
  path: AUTH_URL.ACCEPT_INVITE,
  component: AcceptInvite,
};

const AUTH_ROUTES = Object.freeze({
  LOGIN_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  ACCEPT_INVITE_ROUTE
});

export { AUTH_ROUTES, AUTH_URL };
